import React, { useEffect, useState } from "react";
import "./AddClassForm.css";
import TextFieldInput from "../../../Atoms/Inputs/TextField/TextFieldInput";
import PrimaryButton from "../../../Atoms/Buttons/Primary/PrimaryButton";
import MenuItem from "@mui/material/MenuItem";
import useEdit from "../../../../Hooks/useEdit";
import useSave from "../../../../Hooks/useSave";
import {
  classesURL,
  courseListURL,
  schoolListURL,
  teacherListURL,
} from "../../../../Hooks/URL";
import { Formik } from "formik";
import * as Yup from "yup";
import useFetch from "../../../../Hooks/useFetch";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { DatePicker } from "@mui/x-date-pickers";
import { useNavigate } from "react-router-dom";
import { PulseLoader } from "react-spinners";
import useFetchWhen from "../../../../Hooks/useFetchWhen";

const AdminClassSchema = Yup.object().shape({
  name: Yup.string().required("Class name required !!"),
  schoolId: Yup.string().required("School required !!"),
  courseId: Yup.string().required("Program required !!"),
  teacherId: Yup.string().required("Teacher required !!"),
});

const SchoolClassSchema = Yup.object().shape({
  name: Yup.string().required("Class name required !!"),
  courseId: Yup.string().required("Program required !!"),
  teacherId: Yup.string().required("Teacher required !!"),
});

const TeacherClassSchema = Yup.object().shape({
  name: Yup.string().required("Class name required !!"),
  courseId: Yup.string().required("Program required !!"),
});

const ClassEditSchema = Yup.object().shape({
  name: Yup.string().required("Class name required !!"),
  teacherId: Yup.string().required("Teacher required !!"),
});

function AddClassForm({
  role,
  Edit = false,
  Class,
  url,
  navigate,
  page,
  search,
}) {
  const [newObject, setNewObject] = useState({});
  const [schoolID, setSchoolID] = useState(Class?.school?.id ?? "");
  const [date, setDate] = useState(dayjs(Class?.startDate) ?? "");
  const [goEdit, setGoEdit] = useState(false);
  const [goSave, setGoSave] = useState(false);
  const { state, loading: editLoading } = useEdit(
    `${classesURL}/${Class?.id}`,
    goEdit,
    setGoEdit,
    newObject,
    false,
    false
  );
  const { saveState, loading: addLoading } = useSave({
    url: classesURL,
    goSave,
    setGoSave,
    newObject,
  });
  const { data: schoolsList } = useFetch(
    Edit ? "" : role == "admin" ? schoolListURL : ""
  );
  const { data: teachersList } = useFetch(
    role == "admin"
      ? `${teacherListURL}?schoolId=${schoolID}`
      : role == "school"
      ? teacherListURL
      : "",
    null,
    null,
    role == "admin" ? schoolID : "",
    null,
    role == "admin" ? true : false
  );

  const { data: skillcodeTeachersList } = useFetchWhen(
    `${teacherListURL}?schoolId=${-1}`,
    role == "admin"
  );

  const { data: coursesList } = useFetch(
    role == "admin"
      ? `${courseListURL}?schoolId=${schoolID}`
      : role == "school"
      ? courseListURL
      : "",
    null,
    null,
    role == "admin" ? schoolID : "",
    null,
    role == "admin" ? true : false
  );

  useEffect(() => {
    if (state.dataRes.status == "success") {
      navigate(`/classes/${Class?.id}`);
    }
  }, [state]);

  useEffect(() => {
    if (saveState.dataRes.status == "success") {
      navigate("/classes");
    }
  }, [saveState]);

  return (
    <div className="CourseSmallFormWrapper">
      <Formik
        initialValues={
          role == "admin"
            ? {
                name: Edit ? Class?.className ?? "" : "",
                schoolId: Edit ? Class?.school?.id ?? "" : "",
                courseId: Edit ? Class?.course?.id ?? "" : "",
                teacherId: Edit ? Class?.teacher?.id ?? "" : "",
              }
            : role == "school"
            ? {
                name: Edit ? Class?.className ?? "" : "",
                courseId: Edit ? Class?.course?.id ?? "" : "",
                teacherId: Edit ? Class?.teacher?.id ?? "" : "",
              }
            : {
                name: Edit ? Class?.className ?? "" : "",
                courseId: Edit ? Class?.course?.id ?? "" : "",
              }
        }
        validationSchema={
          Edit
            ? ClassEditSchema
            : role == "admin"
            ? AdminClassSchema
            : role == "school"
            ? SchoolClassSchema
            : TeacherClassSchema
        }
        onSubmit={(values) => {
          if (Class) {
            const prev =
              role == "admin"
                ? {
                    name: Class?.className ?? "",
                    schoolId: Class?.school?.id ?? "",
                    courseId: Class?.course?.id ?? "",
                    teacherId: Class?.teacher?.id ?? "",
                  }
                : role == "school"
                ? {
                    name: Class?.className ?? "",
                    courseId: Class?.course?.id ?? "",
                    teacherId: Class?.teacher?.id ?? "",
                  }
                : {
                    name: Class?.className ?? "",
                    courseId: Class?.course?.id ?? "",
                  };
            const newObj = { ...values, startDate: date };
            setNewObject(
              Object.fromEntries(
                Object.entries({
                  ...prev,
                  ...newObj,
                }).filter(([key]) => prev[key] != newObj[key])
              )
            );
            setGoEdit(true);
          } else {
            setNewObject({ ...values, startDate: date });
            setGoSave(true);
          }
        }}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
        }) => (
          <form autoComplete="off" onSubmit={handleSubmit}>
            <div className="ClassFormContainer">
              <div className="LeftForm">
                <div style={{ width: "100%" }}>
                  <TextFieldInput
                    label="Class Name"
                    newValue={values.name}
                    name={"name"}
                    change={handleChange}
                    blur={handleBlur}
                    fullWidth
                    className={`Input`}
                    variant="outlined"
                    Required={true}
                    placeholder="Enter class name"
                  />
                  {errors.name && touched.name && errors.name && (
                    <p className="error">
                      {errors.name && touched.name && errors.name}
                    </p>
                  )}
                </div>

                {Edit || role != "admin" ? (
                  ""
                ) : (
                  <div style={{ width: "100%" }}>
                    <TextFieldInput
                      select
                      label="School"
                      newValue={values.schoolId}
                      name={"schoolId"}
                      change={(e) => {
                        handleChange(e);
                        setSchoolID(e.target.value);
                      }}
                      blur={handleBlur}
                      fullWidth
                      className={`Input`}
                      variant="outlined"
                      SelectProps={{
                        displayEmpty: true,
                      }}
                    >
                      <MenuItem value="" className="teacherSelect" disabled>
                        Choose School
                      </MenuItem>
                      {schoolsList?.data?.map((schoolItem) => (
                        <MenuItem value={schoolItem?.id}>
                          {schoolItem?.name}
                        </MenuItem>
                      ))}
                    </TextFieldInput>
                    {errors.schoolId && touched.schoolId && errors.schoolId && (
                      <p className="error">
                        {errors.schoolId && touched.schoolId && errors.schoolId}
                      </p>
                    )}
                  </div>
                )}

                {Edit ? (
                  ""
                ) : (
                  <div style={{ width: "100%" }}>
                    <TextFieldInput
                      select
                      label="Course"
                      newValue={values.courseId}
                      name={"courseId"}
                      change={handleChange}
                      blur={handleBlur}
                      fullWidth
                      className={`Input`}
                      variant="outlined"
                      SelectProps={{
                        displayEmpty: true,
                      }}
                    >
                      <MenuItem value="" className="teacherSelect" disabled>
                        {schoolID || role == "school"
                          ? "Choose Program"
                          : "Please choose school first"}
                      </MenuItem>
                      {coursesList?.data?.map((courseItem) => (
                        <MenuItem value={courseItem?.id}>
                          {courseItem?.title}
                        </MenuItem>
                      ))}
                    </TextFieldInput>
                    {errors.courseId && touched.courseId && errors.courseId && (
                      <p className="error">
                        {errors.courseId && touched.courseId && errors.courseId}
                      </p>
                    )}
                  </div>
                )}

                {role != "teacher" ? (
                  <div style={{ width: "100%" }}>
                    <TextFieldInput
                      select
                      label="Teacher"
                      newValue={
                        role == "admin"
                          ? values.teacherId
                          : teachersList?.data?.find(
                              (teacherItem) =>
                                teacherItem?.id == values.teacherId
                            )
                          ? values.teacherId
                          : null
                      }
                      name={"teacherId"}
                      change={handleChange}
                      blur={handleBlur}
                      fullWidth
                      className={`Input`}
                      variant="outlined"
                      SelectProps={{
                        displayEmpty: true,
                      }}
                    >
                      <MenuItem value="" className="teacherSelect" disabled>
                        {schoolID || role == "school"
                          ? "Choose Teacher"
                          : "Please choose school first"}
                      </MenuItem>
                      {teachersList?.data?.map((teacherItem) => (
                        <MenuItem value={teacherItem?.id}>
                          {teacherItem?.name}
                        </MenuItem>
                      ))}
                      {role == "admin"
                        ? skillcodeTeachersList?.data?.map((teacherItem) => (
                            <MenuItem value={teacherItem?.id}>
                              {teacherItem?.name}
                            </MenuItem>
                          ))
                        : ""}
                    </TextFieldInput>
                    {errors.teacherId &&
                      touched.teacherId &&
                      errors.teacherId && (
                        <p className="error">
                          {errors.teacherId &&
                            touched.teacherId &&
                            errors.teacherId}
                        </p>
                      )}
                  </div>
                ) : (
                  ""
                )}

                <div style={{ width: "100%" }}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DemoContainer components={["DatePicker"]}>
                      <DatePicker
                        className="DataInput"
                        name={"startDate"}
                        label="Start Date"
                        value={date}
                        onChange={(newValue) => setDate(newValue)}
                        fullWidth
                      />
                    </DemoContainer>
                  </LocalizationProvider>
                  {errors.startDate &&
                    touched.startDate &&
                    errors.startDate && (
                      <p className="error">
                        {errors.startDate &&
                          touched.startDate &&
                          errors.startDate}
                      </p>
                    )}
                </div>
              </div>

              <div style={{ display: "flex", justifyContent: "center" }}>
                <button
                  className="actionButton primary addButton"
                  onClick={handleSubmit}
                  disabled={Edit ? editLoading : addLoading}
                >
                  {Edit ? (
                    editLoading ? (
                      <PulseLoader color="white" size={8} />
                    ) : (
                      "Edit"
                    )
                  ) : addLoading ? (
                    <PulseLoader color="white" size={8} />
                  ) : (
                    "Add"
                  )}
                </button>
              </div>
            </div>
          </form>
        )}
      </Formik>
    </div>
  );
}

export default AddClassForm;
